import { observable, action, decorate } from 'mobx';
import Ajax from '../ajax/ajax';

export class PeopleStore {

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    allPeople = [];

    allOwners = [];

    get getEmployees() { return this.allPeople; }

    // setAllPeople = (people) => this.allPeople = people;

    setAllOwners = (owners) => this.allOwners = owners;

    // getAllPeople = () => Ajax.getAllPeople(this.getAllPeopleSuccess, this.getAllPeopleError);

    //getAllPeopleSuccess = (response) => {
        // this.setAllPeople(response.data);
        // let currentUser = response.data.find(x => x.email.trim().toLowerCase() === this.rootStore.userStore.currentUser.email.trim().toLowerCase());
        // if (currentUser !== undefined) {
        //     this.rootStore.userStore.setCurrentUserID(currentUser.id);
        // }
    //}

    //getAllPeopleError = (response) => console.log(response);

    getAllOwners = () => Ajax.getAllOwners(this.getAllOwnersSuccess, this.getAllOwnersError);

    getAllOwnersSuccess = (response) => this.setAllOwners(response.data);

    getAllOwnersError = (response) => console.log(response);

}
decorate(PeopleStore, {
    allPeople: observable,
    setAllPeople: action,
    allOwners: observable,
    setAllOwners: action
})